import styled, { css } from "styled-components";

const typographyMixin = css`
  font-family: ${({ theme, $font }) =>
    theme.typography.fonts[$font || "geist"]};
  font-size: ${({ theme, $variant, $size }) =>
    $size || theme.typography.variants[$variant]?.size};
  font-weight: ${({ theme, $variant, $weight }) =>
    $weight || theme.typography.variants[$variant]?.weight};
  line-height: ${({ theme, $variant }) =>
    theme.typography.variants[$variant]?.lineHeight};
  color: ${({ theme, $color }) => theme.typography.color[$color || "primary"]};
  text-align: ${({ $align }) => $align || "inherit"};
  margin: 0;
  margin-bottom: ${({ theme, $variant, $mb }) =>
    $mb !== undefined ? $mb : theme.typography.variants[$variant]?.mb || "0"};

  ${({ $truncate }) =>
    $truncate &&
    css`
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    `}

  @media (max-width: 767px) {
    font-size: ${({ theme, $variant, $size }) =>
      !$size && theme.typography.variants[$variant]?.mobileSize};
  }
`;

export const StyledText = styled.p`
  ${typographyMixin}
`;
